import { S25Util } from "../../../util/s25-util";

export class DocusignSignature {
    static isValidEmail(email: string | null | undefined): boolean {
        return !!email && S25Util.isValidEmail(email);
    }

    static emailError(name: string | null | undefined, email: string | null | undefined): string | null {
        const who = name?.trim() ? name.trim() : "This contact";
        if (!email?.trim()) return `${who} has no email address`;
        if (!DocusignSignature.isValidEmail(email.trim())) return `${who}'s email is not a valid address`;
        return null;
    }
}
